export default __webpack_public_path__ + "static/media/icon_search_tag_question_black.b9689ef4.svg";